import React, { useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { NotificationContext } from "../redux/NotificationProvider";

const env = require("../EnvironmentVariables.json");

const DisputeDetail = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const notify = useContext(NotificationContext);
  const [amount, setAmount] = useState(state?.requested_amount || state?.total || 0);
  const [confirm, setConfirm] = useState(null); // "accept" | "reject" | null

  if (!state) {
    return <p>Missing state</p>;
  }

  const handleAccept = () => setConfirm("accept");
  const handleReject = () => setConfirm("reject");

  const doAccept = async () => {
    try {
      const response = await fetch(`${env.serverId}/SCO/acceptDispute.php`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: `dispute_id=${state.dispute_id}&amount=${amount}`,
      });
      const data = await response.json();
      if (data.status === "Success") {
        notify("Refund issued", "success");
        navigate("/disputes");
      } else {
        notify(`Error: ${data.message}`, "error");
      }
    } catch (error) {
      console.error("Failed to accept dispute", error);
      notify("An unexpected error occurred while processing the refund.", "error");
    }
  };

  const doReject = async () => {
    try {
      const response = await fetch(`${env.serverId}/SCO/rejectDispute.php`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: `dispute_id=${state.dispute_id}`,
      });
      const data = await response.json();
      if (data.status === "Success") {
        notify("Dispute rejected", "success");
        navigate("/disputes");
      } else {
        notify(`Error: ${data.message}`, "error");
      }
    } catch (error) {
      console.error("Failed to reject dispute", error);
      notify("An unexpected error occurred while rejecting the dispute.", "error");
    }
  };

  return (
    <div style={{ maxWidth: 600, margin: "40px auto" }}>
      <h2>Dispute #{state.dispute_id}</h2>
      <p>
        <strong>Invoice ID:</strong> {state.invoice_id}
      </p>
      <p>
        <strong>Customer:</strong> {state.customer_name}
      </p>
      <p>
        <strong>Total Invoice:</strong> ${state.total}
      </p>
      <p>
        <strong>Reason:</strong> {state.reason}
      </p>

      <TextField
        label="Refund amount (USD)"
        type="number"
        fullWidth
        sx={{ my: 2 }}
        value={amount}
        onChange={(event) => setAmount(event.target.value)}
      />

      <Button variant="contained" color="success" onClick={handleAccept} sx={{ mr: 2 }}>
        Accept & Refund
      </Button>
      <Button variant="outlined" color="error" onClick={handleReject}>
        Reject
      </Button>

      <Dialog open={!!confirm} onClose={() => setConfirm(null)}>
        <DialogTitle>{confirm === "accept" ? "Confirm refund" : "Confirm reject"}</DialogTitle>
        <DialogContent>
          {confirm === "accept" ? `Refund $${amount} to the customer?` : "Reject this refund request?"}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirm(null)}>Cancel</Button>
          {confirm === "accept" ? (
            <Button color="success" onClick={doAccept}>
              Refund
            </Button>
          ) : (
            <Button color="error" onClick={doReject}>
              Reject
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DisputeDetail;
